import { useEffect, useState } from 'react';
import { AgeGateOverlay } from '@hypneuronerd/age-gate';
import { storage } from '@hypneuronerd/storage';
import { ReturnLink } from './components/ReturnLink';
import { MapView } from './components/MapView';
import { DetailPanel } from './components/DetailPanel';
import { SearchBar } from './components/SearchBar';
import type { MapEntity } from './data/types';
import styles from './App.module.css';

const VISITED_KEY = 'atlas:visited';

export function App() {
  const [selected, setSelected] = useState<MapEntity | null>(null);
  const [visited, setVisited] = useState<Set<string>>(() => {
    const arr = storage.get<string[]>(VISITED_KEY, []);
    return new Set(arr);
  });

  // Track visited landmarks
  useEffect(() => {
    if (selected?.type === 'landmark') {
      const key = `landmark:${selected.id}`;
      setVisited((prev) => {
        if (prev.has(key)) return prev;
        const next = new Set(prev);
        next.add(key);
        storage.set(VISITED_KEY, [...next]);
        return next;
      });
    }
  }, [selected]);

  return (
    <>
      <AgeGateOverlay />
      <header className={styles.topNav}>
        <ReturnLink />
        <SearchBar onSelect={(e) => setSelected(e)} />
      </header>

      <main className={styles.stage}>
        <MapView selected={selected} visited={visited} onSelect={setSelected} />
        {selected && (
          <DetailPanel
            selected={selected}
            onClose={() => setSelected(null)}
            onJumpToLandmark={(id) => setSelected({ type: 'landmark', id })}
          />
        )}
      </main>

      <footer className={styles.footer}>
        <p>
          a creative cartography of an inner country. drag to pan, scroll to
          zoom, click anything to read.
        </p>
      </footer>
    </>
  );
}
